import { Dialog } from '@mui/material';

import { LocationsTableContainer } from '../components/locations-table/locations-table.container';
import { RetailerNetworkUpdateHandler } from '../../retailer-connect.types';

type RetailerNetworkAddLocationsDialogProps = {
  open: boolean;
  setDialogOpen: (open: boolean) => void;
  retailerNetworkUpdate: RetailerNetworkUpdateHandler;
  customerId: string;
  retailerNetworkUuid: string;
};

export const RetailerNetworkAddLocationsDialog = ({
  open,
  setDialogOpen,
  retailerNetworkUpdate,
  customerId,
  retailerNetworkUuid,
}: RetailerNetworkAddLocationsDialogProps) => {
  const onClose = () => setDialogOpen(false);

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <LocationsTableContainer
        retailerNetworkUpdate={retailerNetworkUpdate}
        onClose={onClose}
        customerId={customerId}
        retailerNetworkUuid={retailerNetworkUuid}
      />
    </Dialog>
  );
};
